import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AdminServiceService } from 'src/app/_services/AdminService.service';
import { DomSanitizer } from '@angular/platform-browser';
import { FormArrayName } from '@angular/forms';

@Component({
  selector: 'app-emailPreview',
  templateUrl: './emailPreview.component.html',
  styleUrls: ['./emailPreview.component.css']
})
export class EmailPreviewComponent implements OnInit {

  @Input() currentConfigurationId: any;
  @Input() currentTemplateId: any;
  @Input() currentApiKey: any;
  @Output() viewMode = new EventEmitter();

  currentTemplate;
  currentFields: any;
  
  constructor(private _adminService: AdminServiceService, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.loadEmailTemplate();
    this.loadTemplateFields();
  }

  loadEmailTemplate() {
    this._adminService.getEmailTemplate(this.currentApiKey, this.currentConfigurationId, this.currentTemplateId).subscribe(response => {
      this.currentTemplate = this.sanitizer.bypassSecurityTrustHtml(response["content"]);
    });
  }

  loadTemplateFields() {
    this._adminService.getEmailTemplateFields(this.currentApiKey, this.currentConfigurationId, this.currentTemplateId).subscribe(response => {
      this.currentFields = new Array();
      for(var itm in response) {
        this.currentFields.push({
          "variable": response[itm],
          "value": ""
        });
      }
      
      //this.currentTemplate = this.sanitizer.bypassSecurityTrustHtml(response["content"]);
    });

  }

  onViewMode(editMode) {
    this.viewMode.emit(editMode);
  }

  onPreview() {
    this._adminService.getEmailTemplatePreview(this.currentApiKey, this.currentConfigurationId, this.currentTemplateId, this.currentFields).subscribe(response => {
      this.currentTemplate = this.sanitizer.bypassSecurityTrustHtml(response["content"]);
    })
  }
  
}
